import { Emitter } from "@noya-app/emitter";

export interface IClientStorage<K extends string = string> {
  getItem(storageKey: K): string | null;
  setItem(storageKey: K, value: string | null): void;
  addListener(
    storageKey: K,
    listener: (newValue: string | null) => void
  ): () => void;
}

export class ClientStorage<K extends string = string>
  implements IClientStorage<K>
{
  getItem(storageKey: K): string | null {
    if (typeof localStorage === "undefined") {
      return null;
    }

    return localStorage.getItem(storageKey);
  }

  setItem(storageKey: K, value: string | null): void {
    if (typeof localStorage === "undefined") {
      return;
    }

    if (value === null) {
      localStorage.removeItem(storageKey);
    } else {
      localStorage.setItem(storageKey, value);
    }

    this.emitter.emit(storageKey, value);
  }

  emitter = new Emitter<[K, string | null]>();

  _isListening = false;

  addListener(
    storageKey: K,
    listener: (newValue: string | null) => void
  ): () => void {
    // Set up a single listener for all storage events
    if (!this._isListening && typeof window !== "undefined") {
      this._isListening = true;

      window.addEventListener("storage", (event: StorageEvent) => {
        this.emitter.emit(event.key as any, event.newValue);
      });
    }

    return this.emitter.addListener((key, value) => {
      if (key === storageKey) {
        listener(value);
      }
    });
  }
}

export const clientStorage = new ClientStorage();
